import React, { useState, useEffect, useCallback } from 'react';
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    FormControlLabel
} from "@mui/material";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import { AiOutlineSearch } from "react-icons/ai";
import { useDispatch, useSelector } from 'react-redux';
import { addUpdateAccountTypeAdmin } from '../../redux/actions/addUpdateAccountTypeAdmin';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import { getAccountTypeAdmin } from '../../redux/actions/getAccountTypeAdminAction';
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import EditIcon from "@mui/icons-material/Edit";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import Util from "../../validation";

const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

const AccountTypeAdmin = () => {

    const classes = useStyles();

    const [accountType, setaccountType] = useState('');
    const [addOpen, setaddOpen] = useState(false);
    const [addAccountType, setaddAccountType] = useState('');
    const [addUpdateSet, setaddUpdateSet] = useState(false);
    const [addUpdateDescription, setaddUpdateDescription] = useState('');
    const [notificationOpen, setnotificationOpen] = useState(false);
    const [tableData, settableData] = useState([]);
    const [isLoading, setisLoading] = useState(false);
    const [accountTypeList, setaccountTypeList] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [page, setPage] = useState(0);
    const [editOpen, seteditOpen] = useState(false);
    const [editedName, seteditedName] = useState('');
    const [editedId, seteditedId] = useState('');
    const [editSet, seteditSet] = useState(false);

    const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
    const addUpdateAccountTypeRes = useSelector(({ addUpdateAccountTypeAdmin }) => addUpdateAccountTypeAdmin);
    const getAccountTypeAdminRes = useSelector(({ getAccountTypeAdmin }) => getAccountTypeAdmin);
    // var authToken = regenerateTokenRes.data.AuthToken;
    const authToken = regenerateTokenRes.data?.AuthToken;

    const dispatch = useDispatch();


    // Function to fetch account type details, memoized with useCallback
    const getAccountTypeDetails = useCallback(() => {
        if (!authToken) {
            // If authToken is not available yet, don't make the call.
            // This can happen on initial render before regenerateToken provides a token.
            console.log("AuthToken not available, skipping getAccountTypeDetails.");
            return;
        }
        setisLoading(true); // Set loading true before dispatching the request
        const req = {
            actionCustomerMasterRequestVO: {
                id: "",
                accountName: ""
            }
        };
        dispatch(getAccountTypeAdmin(req, authToken));
    }, [dispatch, authToken]); // Depend on dispatch and authToken

    // Effect to call getAccountTypeDetails on initial mount and when authToken changes
    useEffect(() => {
        getAccountTypeDetails();
    }, [getAccountTypeDetails]); // Rerun when getAccountTypeDetails (and thus authToken) changes
    // useEffect(() => {
    //     getAccountTypeDetails();
    // }, []);

    // Effect to handle the response of getAccountTypeAdmin
    useEffect(() => {
        if (getAccountTypeAdminRes.data) {
            setisLoading(false); // Stop loading regardless of success/failure
            if (getAccountTypeAdminRes.data.status === 'success') {
                setaccountTypeList(getAccountTypeAdminRes.data.list);
            } else if (getAccountTypeAdminRes.data.status === 'failed') {
                if (getAccountTypeAdminRes.data.description === "session out") {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                } else if (getAccountTypeAdminRes.data.description === "Authorization failed") {
                    // Regenerate token and then retry getAccountTypeDetails
                    dispatch(regenerateToken(authToken, regenerateTokenRes.data.partnerId));
                }
            }
        }
    }, [getAccountTypeAdminRes.data, dispatch, authToken, regenerateTokenRes.data.partnerId]); // Add partnerId to dependencies

    // Effect to re-fetch account type details after a successful token regeneration
    useEffect(() => {
        if (regenerateTokenRes.data?.status === 'success' && regenerateTokenRes.data?.AuthToken !== authToken) {
            // If token regeneration was successful and the authToken has actually changed,
            // then re-fetch account type details with the new token.
            getAccountTypeDetails();
        }
    }, [regenerateTokenRes.data, getAccountTypeDetails, authToken]);


    const setDropdownValues = () => {
        if (getAccountTypeAdminRes.data.status === 'success') {
            setaccountTypeList(getAccountTypeAdminRes.data.list);
            setisLoading(false);
        }
        if (getAccountTypeAdminRes.data.status === 'failed') {
            if (
                getAccountTypeAdminRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                getAccountTypeAdminRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    }

    useEffect(() => {
        setDropdownValues()
    }, [getAccountTypeAdminRes.data.status]);

    // const getAccountTypeDetails = () => {
    //     const req = {
    //         actionCustomerMasterRequestVO: {
    //             id: "",
    //             accountName: ""
    //         }
    //     }
    //     dispatch(getAccountTypeAdmin(req, authToken));
    // }

    const handleChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'accountType') {
            setaccountType(value)
        }
    }

    const addUpdateRespFunc = () => {
        if (addUpdateSet) {
            if (addUpdateAccountTypeRes.data.status === 'success') {
                setaddUpdateDescription(addUpdateAccountTypeRes.data.description);
                setDropdownValues();
                getAccountTypeDetails();
                setaddOpen(false);
                setnotificationOpen(true);
            }
            if (addUpdateAccountTypeRes.data.status === 'failed') {
                setaddUpdateDescription(addUpdateAccountTypeRes.data.description);
                submitSearch()
                setaddOpen(false);
                setnotificationOpen(true);
                if (
                    addUpdateAccountTypeRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    addUpdateAccountTypeRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }

    useEffect(() => {
        addUpdateRespFunc();
    }, [addUpdateAccountTypeRes.data.status]);

    useEffect(() => {
        editRespFunc();
    }, [addUpdateAccountTypeRes.data.status]);

    const editRespFunc = () => {
        if (editSet) {
            if (addUpdateAccountTypeRes.data.status === 'success') {
                setaddUpdateDescription(addUpdateAccountTypeRes.data.description);
                setDropdownValues();
                getAccountTypeDetails();
                seteditOpen(false);
                setnotificationOpen(true);
            }
            if (addUpdateAccountTypeRes.data.status === 'failed') {
                setaddUpdateDescription(addUpdateAccountTypeRes.data.description);
                submitSearch()
                seteditOpen(false);
                setnotificationOpen(true);
                if (
                    addUpdateAccountTypeRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    addUpdateAccountTypeRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }

    const submitSearch = () => {
        setPage(0)
        accountTypeList.filter(ch => ch.accountName == accountType ? ch : '').length == 0 ?
            settableData([].concat(accountTypeList)) : settableData([].concat(accountTypeList.filter(ch => ch.accountName == accountType ? ch : '')))
    }

    const addModalOpen = () => {
        setaddOpen(true)
    }

    const onInputChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'addAccountType') {
            // setaddAccountType(value)
            Util.alphaNumeric(value) ? setaddAccountType(value) : setaddAccountType(addAccountType);
        }
    }

    const addUpdateSubmitFunc = () => {
        setaddUpdateSet(true);
        const req = {
            actionCustomerMasterRequestVO: {
                id: "",
                accountName: addAccountType
            }
        }
        dispatch(addUpdateAccountTypeAdmin(req, authToken));
    }

    const handleClose = () => {
        setaddOpen(false);
        setaddAccountType('');
    }

    const handleNoticationClose = () => {
        setaccountType('');
        submitSearch();
        setnotificationOpen(false)
        setaddUpdateDescription('');
        setaddAccountType('');
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const getAllAccountType = () => {
        if (addUpdateSet) {
            if (addUpdateAccountTypeRes.data.status === 'success') {
                settableData([].concat(getAccountTypeAdminRes.data.list))
            }
            if (addUpdateAccountTypeRes.data.status === 'failed') {
                if (
                    addUpdateAccountTypeRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    addUpdateAccountTypeRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
        setaddUpdateSet(false);
    }

    useEffect(() => {
        getAllAccountType();
    }, [accountTypeList]);

    useEffect(() => {
        if (getAccountTypeAdminRes.data.status === 'success') {
            submitSearch();
        }
        if (getAccountTypeAdminRes.data.status === 'failed') {
            if (
                getAccountTypeAdminRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                getAccountTypeAdminRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    }, []);

    const editModal = (id, name) => {
        seteditedName(name);
        seteditedId(id);
        seteditOpen(true);
    }

    const editHandleChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'editedId') {
            seteditedId(value);
        }
        if (name === 'editedName') {
            // seteditedName(value)
            Util.alphaNumeric(value) ? seteditedName(value) : seteditedName(editedName);
        }
    }

    const closeEditModal = () => {
        seteditOpen(false)
    }

    const editSubmitFunc = () => {
        const req = {
            actionCustomerMasterRequestVO: {
                id: editedId,
                accountName: editedName
            }
        }
        dispatch(addUpdateAccountTypeAdmin(req, authToken));
        seteditSet(true);
        seteditOpen(false);
    }

    return (
        <>
            <Layout>
                <Card>
                    <Grid
                        container
                        style={{
                            padding: "10px",
                            marginTop: "1rem",
                            marginLeft: "1rem",
                            gap: "10px",
                            textAlign: "center"
                        }}
                    >
                        <Grid item xs={12} md={4} sm={3} lg={5}></Grid>
                        <Grid item xs={12} md={3} sm={3} lg={3}>
                            <CustomButton
                                variant="contained"
                                style={{
                                    padding: "8px"
                                }}
                                onClick={addModalOpen}
                            >
                                Add Account Type
                            </CustomButton>
                        </Grid>
                        <Grid item xs={12} md={3} sm={3} lg={3}>
                            <NavLink to="/index/mappingAccountType">
                                <CustomButton
                                    variant="contained"
                                    style={{
                                        padding: "8px"
                                    }}
                                >
                                    Mapping Account Type
                                </CustomButton>
                            </NavLink>
                        </Grid>
                    </Grid>

                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                variant='standard'
                                label="Select Account Type"
                                fullWidth={true}
                                name="accountType"
                                value={accountType || ''}
                                onChange={handleChange}
                            >
                                <MenuItem
                                    value="Select Account Type"
                                    selected="Select Account Type"
                                >
                                    Select Account Type
                                </MenuItem>
                                {accountTypeList &&
                                    [].concat(accountTypeList).map((x, index) => (
                                        <MenuItem key={index} value={x.accountName}>
                                            {x.accountName}
                                        </MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                    margin: "8px 8px"
                                }}
                                variant="contained"
                                onClick={submitSearch}
                            >
                                Search
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>

                <div>
                    <Dialog open={editOpen} onClose={closeEditModal}>
                        <DialogTitle style={{ minWidth: "600px" }}>
                            Edit Account Type
                        </DialogTitle>
                        <DialogContent>
                            <TextField
                                required
                                style={{ marginTop: "10px" }}
                                size="small"
                                disabled
                                color="primary"
                                type="text"
                                label="Account Type Id"
                                fullWidth={true}
                                name="editedId"
                                value={editedId || ""}
                                onChange={editHandleChange}
                            ></TextField>
                            <TextField
                                required
                                style={{ marginTop: "10px" }}
                                size="small"
                                color="primary"
                                type="text"
                                label="Account Type Name"
                                fullWidth={true}
                                name="editedName"
                                value={editedName || ""}
                                onChange={editHandleChange}
                            ></TextField>
                        </DialogContent>
                        <DialogActions style={{ padding: "14px" }}>
                            <CustomButton
                                style={{

                                    color: "white"
                                }}
                                variant="contained"
                                onClick={closeEditModal}
                            >
                                Cancel
                            </CustomButton>
                            <CustomButton
                                style={{

                                    color: "white"
                                }}
                                variant="contained"
                                onClick={editSubmitFunc}
                            >
                                Save
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>

                <div>
                    <Dialog open={addOpen} onClose={handleClose}>
                        <DialogTitle style={{ minWidth: "600px" }}>
                            Add Account Type
                        </DialogTitle>
                        <DialogContent>
                            <TextField
                                required
                                style={{ marginTop: "10px" }}
                                size="small"
                                color="primary"
                                type="text"
                                variant='standard'
                                label="Account Type"
                                fullWidth={true}
                                name="addAccountType"
                                value={addAccountType || ""}
                                onChange={onInputChange}
                            ></TextField>

                        </DialogContent>
                        <DialogActions style={{ padding: "14px" }}>
                            <CustomButton
                                style={{
                                    // backgroundColor: "#fff",
                                    // color: "#000",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleClose}
                            >
                                Cancel
                            </CustomButton>
                            <CustomButton
                                style={{
                                    // backgroundColor: "#fff",
                                    // color: "#000",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={addUpdateSubmitFunc}
                            >
                                Save
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
                {
                    isLoading ? (<LoadingSpinner />) : tableData == undefined || !tableData || tableData.length == 0 ||
                        getAccountTypeAdminRes.data.status === 'NOT FOUND' ? (
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant="body1" style={{ fontWeight: "700" }}
                                        className="themeText"
                                    >
                                        Report Table
                                    </Typography>
                                </Grid>
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Alert
                                        className="my-3 tableHeaderColor"
                                        variant="secondary"

                                        style={{ color: "white" }}
                                    >
                                        No Records Found!
                                    </Alert>
                                </Grid>
                            </Grid>
                        </Card>
                    ) : (
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant="body1" style={{ fontWeight: "700" }}
                                        className="themeText"
                                    >
                                        Report Table
                                    </Typography>
                                </Grid>
                                <TableContainer component={Paper} className="my-3">
                                    <Table
                                        className={classes.table}
                                        size="small"
                                        aria-label="a dense table"
                                    >
                                        <TableHead>
                                            <TableRow className='tableHeaderColor'>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    ID
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Account Type
                                                </TableCell>
                                                <TableCell
                                                    colSpan={2}
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Action
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {tableData &&
                                                []
                                                    .concat(tableData)
                                                    .slice(
                                                        page * rowsPerPage,
                                                        page * rowsPerPage + rowsPerPage
                                                    )
                                                    .map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center">
                                                                {row.id}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.accountName}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <CustomButton
                                                                    style={{
                                                                        padding: "8px"
                                                                    }}
                                                                    onClick={() => editModal(row.id, row.accountName)}
                                                                >
                                                                    <EditIcon style={{ color: "#fff" }} />
                                                                </CustomButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={[].concat(tableData).length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </TableContainer>
                            </Grid>
                        </Card>
                    )
                }
            </Layout>

            {addUpdateAccountTypeRes.data.status == "success" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {addUpdateDescription}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {addUpdateAccountTypeRes.data.status == "failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {addUpdateDescription}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    )
}

export default AccountTypeAdmin